import { fetchVisitorCountry } from "./client";
import { safeReadSessionJson, safeWriteSessionJson } from "./storage";

const STORAGE_KEY = "tracking.visitorCountry.v1";

export const getCachedVisitorCountry = () => {
  const value = safeReadSessionJson(STORAGE_KEY, null);
  return value && typeof value === "object"
    ? {
        countryCode: value.countryCode ?? null,
        countryName: value.countryName ?? null,
        continent: value.continent ?? null,
      }
    : { countryCode: null, countryName: null, continent: null };
};

export const initVisitorCountry = async () => {
  const cached = safeReadSessionJson(STORAGE_KEY, null);
  if (cached) return getCachedVisitorCountry();

  const result = await fetchVisitorCountry();
  safeWriteSessionJson(STORAGE_KEY, result);
  return result;
};
